import {
  ChangeDetectionStrategy,
  Component,
  ViewChild,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { coreRoutesNames } from 'src/core/routes/core.routes.names';
import { AuthStore } from 'src/core/stores';
import { AvatarComponent } from '../avatar/avatar.component';
import { DropdownComponent } from '../elements/dropdown/dropdown.component';

@Component({
  selector: 'core-user-profile-menu',
  templateUrl: './user-profile-menu.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, DropdownComponent, AvatarComponent],
})
export class UserProfileMenuComponent {
  router = inject(Router);
  authStore = inject(AuthStore);

  @ViewChild(DropdownComponent) dropdownComponent!: DropdownComponent;

  navigateToEditProfile() {
    this.router.navigate([coreRoutesNames.PROFILE]);
    this.dropdownComponent.closeDropdown();
  }

  signOut() {
    this.authStore.logout();
    this.dropdownComponent.closeDropdown();
  }
}
